import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=72103598&"
import script from "./Seats.vue?vue&type=script&lang=js&"
export * from "./Seats.vue?vue&type=script&lang=js&"
import style0 from "./Seats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports